module.exports = __webpack_public_path__ + "img/1920x1080_area_inundable.55e8a453.png";